<!-- eslint-disable vue/attribute-hyphenation -->
<template>
  <SnackBar ref="snackbar" />
  <v-container fluid>
    <v-data-table :headers="headers" :items="projetos" :sort-by="[{ key: 'id', order: 'asc' }]" :search="search"
      class="elevation-1">
      <template #top>
        <v-toolbar flat>
          <v-toolbar-title style="font-size: 22px; font-weight: bold">Projetos</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <div class="flex">
            <v-text-field v-model="search" append-icon="mdi-magnify" label="Pesquisar" single-line outline hide-details
              variant="underlined" style="width: 40%"></v-text-field>
            <ModalCadastrarProjeto style="margin-right: 40px" />
          </div>
          <v-dialog v-model="githubDialog" max-width="900px">
            <v-card>
              <v-card-title>
                Associar projeto ao GitHub
              </v-card-title>

              <v-card-text>

                <!-- Seleção do repositório -->

                <v-row>
                  <v-col cols="12">
                    <v-autocomplete v-model="repositoriosSelecionados" :items="listaRepositorios"
                      label="Nome do repositório" multiple chips closable-chips no-data-text="Sem repositórios"
                      @update:modelValue="carregarPreview" />
                  </v-col>
                </v-row>

                <!-- Nome da equipe -->

                <v-row v-if="membrosGithub.length > 0" class="mt-2">
                  <v-col cols="12">
                    <h3>Equipe {{ nomeDaEquipe[0] }}</h3>
                  </v-col>
                </v-row>

                <!-- Tabela -->

                <v-row v-if="membrosGithub.length > 0">
                  <v-col cols="12">
                    <v-radio-group v-model="administradorSelecionado">
                      <v-data-table :headers="headersGithub" :items="membrosGithub" density="comfortable"
                        hide-default-footer>

                        <!-- Coluna Administrador -->

                        <template #[`item.administrador`]="{ item }">

                          <v-radio v-if="podeSerAdministrador(item.raw)" v-model="administradorSelecionado"
                            :value="item.raw.idUsuario" />

                          <v-icon v-else color="grey">
                            mdi-lock
                          </v-icon>

                        </template>
                      </v-data-table>

                    </v-radio-group>

                  </v-col>
                </v-row>

              </v-card-text>

              <v-card-actions>

                <v-spacer />

                <v-btn color="red" @click="closeGitDialog">
                  Cancelar
                </v-btn>

                <v-btn color="primary" @click="associarGithub">
                  Associar
                </v-btn>

              </v-card-actions>

            </v-card>
          </v-dialog>

          <v-dialog v-model="dialog" max-width="850px">
            <v-card>
              <v-card-title>
                <span class="text-h5">Visualizar Projeto</span>
              </v-card-title>

              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="8">
                      <v-text-field v-model="editedItem.nome" variant="underlined" label="Nome" readonly></v-text-field>
                    </v-col>
                    <v-col cols="4">
                      <v-text-field v-model="editedItem.sigla" variant="underlined" label="Sigla"
                        readonly></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-label>Equipe {{ this.nomeDaEquipe[0] }}</v-label>
                      <v-container class="d-flex" v-if="isLoading">
                        <v-skeleton-loader class="skeleton-wrapper" type="list-item-two-line" :loading="isLoading"
                          v-for="index in 3" :key="index"></v-skeleton-loader>
                      </v-container>

                      <v-card class="my-4">
                        <v-card-text>
                          <v-list class="d-flex flex-wrap" :min-width="150" lines="one">
                            <v-list-item v-for="item in equipeMembros" :key="item.nomeEqui" :title="item.nomeEqui"
                              :subtitle="item.formaAtuacao === 'SCRUM_MASTER'
                                  ? 'SCRUM MASTER'
                                  : item.formaAtuacao
                                "></v-list-item>
                          </v-list>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-label>Stakeholders</v-label>
                      <br />
                      <v-container class="d-flex" v-if="isLoading">
                        <v-skeleton-loader class="skeleton-wrapper" type="list-item-two-line" :loading="isLoading"
                          v-for="index in 4" :key="index"></v-skeleton-loader>
                      </v-container>
                      <v-list class="d-flex flex-wrap" :min-width="150" lines="two" v-if="stakeholders.length > 0">
                        <v-list-item v-for="item in stakeholders" :key="item.nome" :title="item.nome"
                          :subtitle="`${item.email}`"></v-list-item>
                      </v-list>

                      <p v-if="this.messageStake != ''">
                        {{ this.messageStake }}
                      </p>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-label>Repositórios</v-label>
                      <v-container class="d-flex" v-if="isLoading">
                        <v-skeleton-loader class="skeleton-wrapper" type="list-item-two-line" :loading="isLoading"
                          v-for="index in 3" :key="index"></v-skeleton-loader>
                      </v-container>
                      <v-list class="d-flex flex-wrap" :min-width="150" lines="one" v-else-if="repositorios.length > 0">
                        <v-list-item v-for="repositorio in repositorios"
                          :key="repositorio.tb_repositorio.id_repositorio" :title="repositorio.tb_repositorio.nome"
                          :link="true" @click="redirect(repositorio.tb_repositorio.url)"
                          :subtitle="`${repositorio.tb_repositorio.owner}`" elevation="2"
                          class="repo-item"></v-list-item>
                      </v-list>
                      <p v-else>
                        {{ this.messageRepo }}
                      </p>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-textarea v-model="editedItem.descricao" variant="outlined" label="Descrição" readonly no-resize
                        rows="2"></v-textarea>
                    </v-col>
                  </v-row>
                  <v-row class="justify-content-center mb-6">
                    <v-col cols="12">
                      <!-- <v-btn
                        class="mr-4"
                        color="#004984"
                        @click="this.dialog = false"
                        variant="outlined"
                        >Voltar</v-btn
                      > -->

                      <v-tooltip location="bottom" text="Associar este projeto ao Github">
                        <template #activator="{ props }">
                          <v-btn prepend-icon="mdi-github" class="mr-4" color="danger" v-bind="props"
                            @click="githubDialog = true">Associar repositório</v-btn>
                        </template>
                      </v-tooltip>
                      <v-tooltip location="bottom" text="Editar Projeto">
                        <template #activator="{ props }">
                          <v-btn prepend-icon="mdi-pencil" class="mr-4" v-bind="props"
                            @click="dialogProjeto = true">Editar Projeto</v-btn>
                        </template>
                      </v-tooltip>
                      <!-- <v-btn
                        prepend-icon="mdi-account-group"
                        class="mr-4"
                        color="#004984"
                        @click="verEquipe"
                        disabled
                        title="Definir equipe para este projeto"
                        style="color: white"
                        >Equipe</v-btn
                      > -->
                      <ModalEncerrarProjeto :sigla="this.editedItem.sigla" :id="this.idProjeto"
                        :encerrado="this.editedItem.flencerrado" />
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-card>
          </v-dialog>

          <!-- Editar Projeto -->
          <v-dialog v-model="dialogProjeto" max-width="850px">
            <v-card>
              <v-card-title>
                <span class="text-h5">Editar Projeto</span>
              </v-card-title>

              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="8">
                      <v-text-field v-model="editedItem.nome" variant="underlined" label="Nome"></v-text-field>
                    </v-col>
                    <v-col cols="4">
                      <v-text-field v-model="editedItem.sigla" variant="underlined" label="Sigla"></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-label>Equipe {{ this.nomeDaEquipe[0] }}</v-label>
                      <v-container class="d-flex" v-if="isLoading">
                        <v-skeleton-loader class="skeleton-wrapper" type="list-item-two-line" :loading="isLoading"
                          v-for="index in 3" :key="index"></v-skeleton-loader>
                      </v-container>
                      <v-list class="d-flex flex-wrap" :min-width="150" lines="one" disabled v-else>
                        <v-list-item v-for="item in equipeMembros" :key="item.nomeEqui" :title="item.nomeEqui"
                          :subtitle="item.formaAtuacao === 'SCRUM_MASTER'
                              ? 'SCRUM MASTER'
                              : item.formaAtuacao
                            "></v-list-item>
                      </v-list>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-label>Repositórios</v-label>
                      <v-container class="d-flex" v-if="isLoading">
                        <v-skeleton-loader class="skeleton-wrapper" type="list-item-two-line" :loading="isLoading"
                          v-for="index in 3" :key="index"></v-skeleton-loader>
                      </v-container>
                      <v-list class="d-flex flex-wrap" :min-width="150" lines="one" v-if="repositorios.length > 0">
                        <v-list-item v-for="repositorio in repositorios"
                          :key="repositorio.tb_repositorio.id_repositorio" :title="repositorio.tb_repositorio.nome"
                          :link="true" :subtitle="`${repositorio.tb_repositorio.owner}`" elevation="2" class="repo-item"
                          :class="{ 'shake-animation': repositorio.shaking }">
                          <template #append>
                            <v-btn small color="red" variant="text" icon="mdi-close"
                              @click="confirmarRemocaoRepositorio(repositorio)"></v-btn>
                          </template>
                        </v-list-item>
                      </v-list>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-textarea v-model="editedItem.descricao" variant="outlined" label="Descrição" no-resize
                        hint="Utilize uma descrição de no máximo 68 caracteres" rows="2"></v-textarea>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue-darken-1" variant="text" @click="dialogProjeto = false">
                  Cancelar
                </v-btn>
                <v-btn color="blue-darken-1" variant="text" @click="atualizarProjeto(editedItem)">
                  Atualizar
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template #[`item.actions`]="{ item }">
        <div class="justify-content-center">
          <v-tooltip text="Visualizar Projeto" location="bottom">
            <template #activator="{ props }">
              <v-icon v-bind="props" size="small" class="me-2" @click="showItem(item.raw)">
                mdi-eye
              </v-icon>
            </template>
          </v-tooltip>
          <v-tooltip text="Editar Projeto" location="bottom">
            <template #activator="{ props }">
              <v-icon v-bind="props" size="small" class="me-2" @click="editItem(item.raw)">
                mdi-pencil
              </v-icon>
            </template>
          </v-tooltip>
          <v-tooltip text="Avaliações" location="bottom">
            <template #activator="{ props }">
              <v-icon v-bind="props" size="small" class="me-2" @click="visualizarAvaliacao(item.raw)">
                mdi-star
              </v-icon>
            </template>
          </v-tooltip>

          <v-tooltip text="Sprints" location="bottom">
            <template #activator="{ props }">
              <v-icon v-bind="props" size="small" class="me-2" @click="retornaIdProjSprints(item.raw)">
                mdi-flag
              </v-icon>
            </template>
          </v-tooltip>

          <v-tooltip text="Backlog de Tarefas" location="bottom">
            <template #activator="{ props }">
              <v-icon v-bind="props" size="small" class="me-2" @click="retornaIdProjTarefas(item.raw)">
                mdi-clipboard-list
              </v-icon>
            </template>
          </v-tooltip>

          <RouterLink :to="'/projects/' + item.raw.idproj" style="text-decoration: none; color: inherit">
            <v-tooltip text="Requisitos" location="bottom">
              <template #activator="{ props }">
                <v-icon size="small" v-bind="props" class="me-2" @click="funcaoReq(item.raw)">
                  mdi-arrow-top-right-thin-circle-outline
                </v-icon>
              </template>
            </v-tooltip>
          </RouterLink>
          <RouterLink
            :to="'/project-validation/' + item.raw.idproj"
            style="text-decoration: none; color: inherit"
          >
            <v-tooltip text="Validação" location="bottom">
              <template #activator="{ props }">
                <v-icon
                  size="small"
                  v-bind="props"
                  class="me-2"
                  @click="funcaoReq(item.raw)"
                >
                  mdi-account-check
                </v-icon>
              </template>
            </v-tooltip>
          </RouterLink>
        </div>
      </template>
      <template #no-data>
        <div class="text-center py-6">
          <span> Sem projetos a listar </span>
        </div>
      </template>
      <!-- <template v-slot:bottom>
        <div class="text-center pt-2">
          <v-pagination v-model="page" :length="pageCount"></v-pagination>
        </div>
      </template> -->
    </v-data-table>
  </v-container>
</template>

<script>
import axios from 'axios';
import { VDataTable } from 'vuetify/labs/VDataTable';
import { VSkeletonLoader } from 'vuetify/labs/VSkeletonLoader';

import ModalEncerrarProjeto from '@/components/dialogs/EncerrarProjeto.vue';
import ModalCadastrarProjeto from '@/components/dialogs/ModalCadastrarProjeto.vue';
import SnackBar from '@/components/SnackBar.vue';
import store from '@/store/store';

const API_URL = process.env.VUE_APP_API_URL || 'http://localhost:3000';

export default {
  components: {
    VDataTable,
    ModalCadastrarProjeto,
    ModalEncerrarProjeto,
    SnackBar,
    VSkeletonLoader,
  },
  data: () => ({
    dialog: false,
    administradorSelecionado: null,
    githubDialog: false,
    sprintDialog: false,
    dialogProjeto: false,
    numeroRepositorios: 1,
    organizacao: null,
    // repositórios selecionados para associar ao projeto
    repositoriosSelecionados: [],
    listaRepositorios: [], // todos os repos da org
    listaRepositoriosAssoc: [], // repositórios já associados ao projeto
    repositorios: [], // todas as infos dos repos
    stakeholders: [], // stakeholders do projeto
    messageStake: '',
    messageRepo: '',
    headers: [
      {
        title: '#',
        align: 'start',
        key: 'id',
      },
      { title: 'Sigla', key: 'sigla' },
      { title: 'Nome', key: 'nome' },
      { title: 'Status', key: 'flencerrado' },
      { title: 'Ações', key: 'actions', sortable: false },
    ],
    projetos: [],
    equipeMembros: [],
    nomeDaEquipe: [],
    editedIndex: -1,
    editedItem: {
      sigla: '',
      nome: '',
      flencerrado: '',
      descricao: '',
    },
    defaultItem: {
      sigla: '',
      nome: '',
      flencerrado: '',
      descricao: '',
    },
    isLoading: true,
    search: '',
    removeRepo: [],


    headersGithub: [
      {
        title: 'Administrador',
        key: 'administrador',
        sortable: false,
        width: '120px'
      },
      {
        title: 'Usuário',
        key: 'nome'
      },
      {
        title: 'Forma de Atuação',
        key: 'formaAtuacao'
      },
      {
        title: 'Role GitHub',
        key: 'roleGithub'
      },
      {
        title: 'Role Repo Raiz',
        key: 'roleRepoRaiz'
      }
    ],

    membrosGithub: []
  }),

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogProjeto(val) {
      val || this.close();
    },
  },

  created() {
    this.fetchprojetos();
  },

  methods: {


    podeSerAdministrador(item) {
      return (
        item.formaAtuacao === 'DESENVOLVEDOR' ||
        item.formaAtuacao === 'SCRUM_MASTER'
      );
    },


  confirmarRemocaoRepositorio(repositorio) {
  const confirmar = window.confirm(
    `Confirma a exclusão de acesso do ${this.editedItem.sigla} no repositório ${repositorio.tb_repositorio.nome}?\n\n` +
    `Usuários perderão acesso ao repositório.\n\n` +
    `Esta ação não poderá ser desfeita.`
  );

  if (!confirmar) {
    return;
  }

  this.capturarIdRepo(repositorio);
},


    async carregarPreview() {

      if (this.repositoriosSelecionados.length === 0) {
        this.membrosGithub = [];
        return;
      }

      try {

        const response = await axios.get(
          `${API_URL}/projetos/previewRoleUsers/${this.idProjeto}`, {
          headers: {
            Authorization: `Bearer ${store.state.token}`,
          },
          params: {
            repoSelecteds: this.repositoriosSelecionados
          }
        })

        this.membrosGithub = response.data;

      } catch (error) {
        console.error(error);
        this.membrosGithub = [];
      }

    },
    /**
     * Acarreta uma ação de fechar o modal de associar repositório.
     *
     * @function closeGitDialog
     * @returns {void}
     */
    closeGitDialog() {
      this.githubDialog = false;
      this.numeroRepositorios = 1;
      this.repositoriosSelecionados = [];
    },

    visualizarAvaliacao(item) {
      this.idProjeto = item.idproj;
      this.$router.push({
        name: 'ratingCoord',
        params: { id: parseInt(this.idProjeto), nome: item.nome },
      });
    },
    retornaIdProjTarefas(item) {
      this.idProjeto = item.idproj;
      this.$router.push({
        name: 'tasks/backlog',
        params: { id: parseInt(this.idProjeto) },
      });
    },
    // Função de inicialização de projeto, sempre preenche com uma req ao back
    /* eslint-disable */
    /**
     * Busca a lista de projetos a partir do backend e preenche o array de projetos
     * @function
     * @name fetchprojetos
     * @memberof TelaListarProj
     * @returns {Promise<void>}
     */
    fetchprojetos() {
      axios
        .get(API_URL + '/projetos/COORDENADOR', {
          headers: {
            Authorization: `Bearer ${store.state.token}`,
          },
        })
        .then((response) => {
          let count = 1;
          response.data.forEach((element) => {
            /* eslint-disable */
            element.fl_coordenador === true
              ? (element.fl_coordenador = 'Coordenador')
              : (element.fl_coordenador = 'Desenvolvedor');
            /* eslint-enable */
            this.projetos.push({
              id: count++,
              idproj: element.id_projeto,
              sigla: element.sigla,
              nome: element.nome,
              flencerrado: element.flencerrado ? 'Encerrado' : 'Ativo',
              descricao: element.descricao,
              idEquipe: element.id_equipe_fk,
            });
          });
          localStorage.setItem(
            'idProjectList',
            JSON.stringify(this.projetos.map((item) => item.idproj)),
          );
        })
        .catch((error) => {
          console.error(error);
        });
    },
    /* eslint-disable */
    /**
     * Faz uma requisição GET para a API de membros de uma equipe e adiciona as informações relevantes de cada membro em um objeto.
     *
     * @function fetchEquipe
     * @param {string} equipe - O nome da equipe para a qual os membros serão listados.
     * @async
     * @returns {Promise<void>}
     */
    fetchEquipe(equipe) {
      axios
        .get(`${API_URL}/equipes/${equipe}`, {
          headers: {
            Authorization: `Bearer ${store.state.token}`,
          },
        })
        .then((response) => {
          this.isLoading = false;
          response.data.forEach((equi) => {
            this.equipeMembros.push({
              nomeEqui: equi.nome,
              formaAtuacao: equi.forma_atuacao,
              nomeEq: equi.nome_equipe,
            });
          });
          this.nomeDaEquipe = this.equipeMembros.map(function (n) {
            return n.nomeEq;
          });
        })
        .catch((error) => {
          console.error(error);
        });
    },

    /**
     * Atualiza o estado de um item selecionado para ser editado e abre um diálogo para exibir as informações do item. Também faz uma requisição para obter os membros da equipe do item selecionado.
     *
     * @function showItem
     * @param {object} item - O objeto do item selecionado.
     * @returns {void}
     */
    showItem(item) {
      this.editedIndex = this.projetos.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.editedItem.sigla = item.sigla;
      this.editedItem.flencerrado = item.flencerrado;
      this.idProjeto = item.idproj;
      this.dialog = true;
      axios
        .get(API_URL + `/projetos/${this.idProjeto}/org`, {
          headers: {
            Authorization: `Bearer ${store.state.token}`,
          },
        })
        .then((response) => {
          this.organizacao = response.data;
        })
        .catch((error) => {
          console.error(error);
        });
      this.fetchEquipe(item.idEquipe);
      this.fetchRepositorios(item.idproj);
      this.fetchStakeholders(item.idproj);
    },
    retornaIdProjSprints(item) {
      this.idProjeto = item.idproj;
      this.$router.push({
        name: 'sprint',
        params: { id: parseInt(this.idProjeto) },
      });
    },
    retornaIdProjTarefas(item) {
      this.idProjeto = item.idproj;
      this.$router.push({
        name: 'tasks/backlog',
        params: { id: parseInt(this.idProjeto) },
      });
    },
    funcaoReq(item) {
      this.idProjeto = item.idproj;
    },
    /**
     * Faz uma requisição POST para associar um repositório do Github a um projeto.
     *
     * @function associarGithub
     * @async
     * @returns {Promise<void>}
     */
    associarGithub() {

      if (!this.administradorSelecionado) {
        this.$refs.snackbar.showErrorSnackbar(
          'Selecione um administrador para o repositório!'
        );
        return;
      }

      console.log(this.repositoriosSelecionados);
      if (this.repositoriosSelecionados.length != 0) {
        const data = {
          nome: this.repositoriosSelecionados,
          /* eslint-disable */

          id_proj: this.idProjeto,
          id_adm: this.administradorSelecionado,
        };
        console.log(data);
        axios
          .post(API_URL + `/projetos/associarRepo/`, data, {
            headers: {
              Authorization: `Bearer ${store.state.token}`,
            },
          })
          // eslint-disable-next-line no-unused-vars
          .then((response) => {
            this.$refs.snackbar.showSuccessSnackbar(
              'Concluído!',
              'Associação realizada com sucesso!'
            );
            location.reload();
          })
          .catch((error) => {
            console.log(error.response.data.error);
            this.$refs.snackbar.showErrorSnackbar(
              'Hm... Algo deu errado',
              'Por algum motivo, não conseguimos realizar sua associação!'
            );
          });
      } else {
        this.$refs.snackbar.showWarningSnackbar(
          'Campo vazio!',
          'Nenhum repositório selecianado para associar!'
        );
      }
    },
    /**
     * Fecha o diálogo de visualizar de item e reseta o estado do item editado e da lista de membros da equipe.
     *
     * @function close
     * @returns {void}
     */
    close() {
      this.dialog = false;
      this.isLoading = true;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
        this.equipeMembros = [];
        this.stakeholders = [];
      });
    },
    redirect(url) {
      window.open(url, '_blank');
    },
    fetchRepositorios(idProjeto) {
      this.messageRepo = '';
      axios
        .get(API_URL + `/projetos/${idProjeto}/repositorios`, {
          headers: {
            Authorization: `Bearer ${store.state.token}`,
          },
        })
        // eslint-disable-next-line no-unused-vars
        .then((response) => {
          console.log(response.data);
          console.log(response.data.tb);
          this.repositorios = response.data;
          this.listaRepositoriosAssoc = this.repositorios.map(function (item) {
            return item.tb_repositorio.nome;
          });

          if (this.listaRepositoriosAssoc.length === 0) {
            this.messageRepo =
              'Esse projeto ainda não foi associado a um repositório.';
          }
        })
        .catch((error) => {
          console.log(error.response.data.error);
          this.messageRepo = 'Sem repositórios a listar.';
          this.$refs.snackbar.showErrorSnackbar(
            'Hm... Algo deu errado',
            'Por algum motivo, não conseguimos buscar os repositórios!'
          );
        });

      axios
        .get(API_URL + `/projetos/${idProjeto}/org/repos`, {
          headers: {
            Authorization: `Bearer ${store.state.token}`,
          },
        })
        // eslint-disable-next-line no-unused-vars
        .then((response) => {
          console.log(response.data);
          this.listaRepositorios = response.data.filter(
            (elemento) => !this.listaRepositoriosAssoc.includes(elemento)
          );
        })
        .catch((error) => {
          console.log(error.response.data.error);
          this.$refs.snackbar.showErrorSnackbar(
            'Hm... Algo deu errado',
            'Por algum motivo, não conseguimos buscar os repositórios!'
          );
        });
    },

    fetchStakeholders(idProjeto) {
      this.messageStake = '';
      axios
        .get(API_URL + `/projetos/projetostakeholder/${idProjeto}`, {
          headers: {
            Authorization: `Bearer ${store.state.token}`,
          },
        })
        // eslint-disable-next-line no-unused-vars
        .then((response) => {
          console.log(response.data);
          this.stakeholders = response.data.tb_projeto_stakeholder.map(
            function (item) {
              return {
                nome: item.tb_stakeholder_externo.nome,
                email: item.tb_stakeholder_externo.email,
              };
            }
          );
        })
        .catch((error) => {
          console.error(error.response);
          this.messageStake = 'Não há stakeholders cadastrados neste projeto.';
        });
    },
    editItem(item) {
      this.editedIndex = this.projetos.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogProjeto = true;
      this.idProjeto = item.idproj;
      axios
        .get(API_URL + `/projetos/${this.idProjeto}/org`, {
          headers: {
            Authorization: `Bearer ${store.state.token}`,
          },
        })
        .then((response) => {
          this.organizacao = response.data;
        })
        .catch((error) => {
          console.error(error);
        });
      this.fetchEquipe(item.idEquipe);
      this.fetchRepositorios(item.idproj);
    },
    atualizarProjeto(item) {
      /* eslint-disable */
      console.log(item);
      const data = {
        nome: item.nome,
        descricao: item.descricao,
        repo: this.removeRepo,
        sigla: item.sigla
      };
      console.log(data);
      /* eslint-enable */
      const config = {
        headers: {
          Authorization: `Bearer ${store.state.token}`,
        },
      };
      axios
        .patch(API_URL + `/projetos/update/${this.idProjeto}`, data, config)
        .then(() => {
          this.$refs.snackbar.showSuccessSnackbar(
            'Concluído!',
            'Projeto atualizado com sucesso!',
          );
          this.dialogProjeto = false;
          setTimeout(() => {
            window.location.reload();
          }, 3000);
        })
        .catch((error) => {
          console.log(error.response.data.error);
          this.dialogProjeto = false;
          this.$refs.snackbar.showErrorSnackbar(
            'Hm... Algo deu errado',
            `${error.response.data.error}`,
          );
        });
    },
    capturarIdRepo(repositorio) {
      console.log(repositorio.tb_repositorio.id_repositorio);

      if (this.removeRepo.includes(repositorio.tb_repositorio.id_repositorio)) {
        this.removeRepo = this.removeRepo.filter(
          (id) => id !== repositorio.tb_repositorio.id_repositorio,
        );
      } else {
        this.removeRepo.push(repositorio.tb_repositorio.id_repositorio);
      }
      console.log(this.removeRepo);
      repositorio.shaking = !repositorio.shaking;
    },
  },




};
</script>
<style scoped>
.d-flex {
  display: flex;
}

.flex {
  display: flex;
  width: 50%;
  align-items: center;
}

.flex-wrap {
  flex-wrap: wrap;
}

.rounded-btn {
  border-radius: 50%;
  margin-left: 15px;
}

.skeleton-wrapper {
  width: 33%;
  background: transparent;
}

.d-flex {
  padding: 0;
}

.repo-item {
  padding: 10px;
  margin: 10px 5px;
}

.shake-animation {
  animation: shake 0.5s;
  background-color: #ccc;
}

@keyframes shake {

  0%,
  100% {
    transform: translateX(0);
  }

  10%,
  30%,
  50%,
  70%,
  90% {
    transform: translateX(-5px);
  }

  20%,
  40%,
  60%,
  80% {
    transform: translateX(5px);
  }
}
</style>
